import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LocaleId } from '../models/locale.model';
import { ReportRecord } from '../models/report.model';
import { CustomDataRetriever } from './custom-data-retriever.abstract';
import { CustomDataTable } from './offered-space.service';

interface StaticResearchDevelopmentPipeline {
  agent: string;
}

@Injectable()
export class ResearchDevelopmentPipelineService extends CustomDataRetriever {
  constructor(private http: HttpClient) {
    super();
  }

  getCustomData(
    reportId: number,
    templateId: number,
    locale: LocaleId,
    payload: any,
    record: ReportRecord
  ): Observable<StaticResearchDevelopmentPipeline> {
    const researchAvailData$ = this.getResearchDevPipeline(reportId, payload);
    return researchAvailData$.pipe(map(researchAvailData => this.mapResearchDevPipeline(researchAvailData, record)));
  }

  private getResearchDevPipeline(reportId, payload): Observable<CustomDataTable> {
    const uri = `/api/reports/${reportId}/customdata?type=researchDevelopmentPipeline&view=researchDevelopmentPipeline`;
    return this.cachedCustomData(uri, this.http.post.bind(this.http, uri, payload));
  }

  private mapResearchDevPipeline(
    researchAvailData: CustomDataTable,
    record: ReportRecord
  ): StaticResearchDevelopmentPipeline {
    if (researchAvailData == null) {
      return null;
    }
    const { edpRecordId } = record;
    const recordResearchAvailability = researchAvailData[edpRecordId];

    if (recordResearchAvailability == null) {
      return null;
    }

    const { data } = recordResearchAvailability;
    if (Array.isArray(data) && data.length > 1) {
      throw new Error('data must not greater than one element per property');
    } else {
      const [row = []] = data;
      if (!Array.isArray(row)) {
        throw new Error('row data must be an array');
      }
      /*
       * NOTE 1: this mapping should not be happening, but we are using objects
       *         due to windward not supporting the original interface
       * NOTE 2: we have two scenarios: longlist & shortlist. The longlist
       *         only needs the **four** attributes we are sending in the "if"
       *         block. However, the shortlist needs the **eight** attributes we
       *         are sending in the "else" block.
       */
      const [agent = ''] = row;
      return { agent };
    }
  }
}
